<script setup lang="ts">
  import router from '@/router'
  import { useChatStore } from '@stores/chat.ts'
  import { useAuthStore } from '@stores/auth.ts'
  import { useConsultationsStore } from '@stores/consultations.ts'

  const chatStore = useChatStore()
  const authStore = useAuthStore()
  const consultationsStore = useConsultationsStore()
  const logoutDialog = defineModel({
    type: Boolean,
    default: false,
  })
  const logout = async () => {

    useTrackStore().track('logout_clicked')
    try {
      await authStore.logout()
      chatStore.$reset()
      consultationsStore.$reset()

      await router.replace({ path: '/', force: true })
    } catch (e) {
      console.error(e)
    } finally {
      logoutDialog.value = false
    }
  }
</script>

<template>
  <app-dialog
    v-model="logoutDialog"
    :show-close-button="false"
  >
    <div class="d-flex flex-column ga-4">
      <div class="text-center">
        <h3 class="text-grey-100 font-weight-bold logout-title">
          <i18n-t keypath="logout" />
        </h3>
        <p class="text-grey-200">
          <i18n-t keypath="logout_message" />
        </p>
      </div>

      <div class="d-flex flex-column ga-3">
        <v-btn
          block
          class="font-weight-bold"
          color="primary"
          density="default"
          flat
          :loading="authStore.loading"
          size="large"
          @click="logout"
        >
          <i18n-t keypath="logout" />
        </v-btn>
        <v-btn
          class="font-weight-bold"
          flat
          size="large"
          variant="outlined"
          @click="logoutDialog = false"
        >
          <i18n-t keypath="cancel" />
        </v-btn>
      </div>
    </div>
  </app-dialog>
</template>

<style scoped lang="scss">
.logout-title {
  line-height: 28px;
  font-size: 18px;
}
</style>
